import { SpineMeshBase } from "./SpineMeshBase";
export class SpineVirtualMesh extends SpineMeshBase {
    constructor(material) {
        super(material);
        if (SpineVirtualMesh.vertexArray == null) {
            SpineVirtualMesh.vertexArray = new Float32Array(SpineMeshBase.maxVertex * SpineVirtualMesh.vertexSize_TwoColor);
            SpineVirtualMesh.indexArray = new Uint16Array(SpineMeshBase.maxVertex * 3);
        }
        this.vertexArray = SpineVirtualMesh.vertexArray;
        this.indexArray = SpineVirtualMesh.indexArray;
    }
    appendVerticesClip(vertices, indices) {
        let indicesLength = indices.length;
        let verticesLength = vertices.length;
        let vertexSize = SpineVirtualMesh.vertexSize_TwoColor;
        let vertexBuffer = this.vertexArray;
        let before = this.verticesLength;
        let indexStart = before / vertexSize;
        let vlen = before;
        for (let j = 0; j < verticesLength; vlen += vertexSize, j += vertexSize) {
            vertexBuffer[vlen] = vertices[j + 6];
            vertexBuffer[vlen + 1] = vertices[j + 7];
            vertexBuffer[vlen + 2] = vertices[j + 2];
            vertexBuffer[vlen + 3] = vertices[j + 3];
            vertexBuffer[vlen + 4] = vertices[j + 4];
            vertexBuffer[vlen + 5] = vertices[j + 5];
            vertexBuffer[vlen + 6] = vertices[j];
            vertexBuffer[vlen + 7] = vertices[j + 1];
            vertexBuffer[vlen + 8] = vertices[j + 8];
            vertexBuffer[vlen + 9] = vertices[j + 9];
            vertexBuffer[vlen + 10] = vertices[j + 10];
            vertexBuffer[vlen + 11] = vertices[j + 11];
        }
        this.verticesLength = before + verticesLength;
        let indicesArray = this.indexArray;
        for (let i = this.indicesLength, j = 0; j < indicesLength; i++, j++)
            indicesArray[i] = indices[j] + indexStart;
        this.indicesLength += indicesLength;
    }
    canAppend(verticesLength, indicesLength) {
        return this.verticesLength + verticesLength < SpineVirtualMesh.maxVertex * SpineVirtualMesh.vertexSize_TwoColor && this.indicesLength + indicesLength < SpineVirtualMesh.maxVertex * 3;
    }
    appendVertices(vertices, verticesLength, indices, indicesLength, finalColor, darkColor, uvs) {
        let vertexSize = SpineVirtualMesh.vertexSize_TwoColor;
        let indexStart = this.verticesLength / vertexSize;
        let vertexBuffer = this.vertexArray;
        let before = this.verticesLength;
        for (let u = 0, v = 0, n = verticesLength; v < n; v += vertexSize, u += 2) {
            let size = before + v;
            vertexBuffer[size] = uvs[u];
            vertexBuffer[size + 1] = uvs[u + 1];
            vertexBuffer[size + 2] = finalColor.r;
            vertexBuffer[size + 3] = finalColor.g;
            vertexBuffer[size + 4] = finalColor.b;
            vertexBuffer[size + 5] = finalColor.a;
            vertexBuffer[size + 6] = vertices[v];
            vertexBuffer[size + 7] = vertices[v + 1];
            vertexBuffer[size + 8] = darkColor.r;
            vertexBuffer[size + 9] = darkColor.g;
            vertexBuffer[size + 10] = darkColor.b;
            vertexBuffer[size + 11] = darkColor.a;
        }
        this.verticesLength = before + verticesLength;
        let indicesArray = this.indexArray;
        for (let i = this.indicesLength, j = 0; j < indicesLength; i++, j++)
            indicesArray[i] = indices[j] + indexStart;
        this.indicesLength += indicesLength;
    }
}
SpineVirtualMesh.vertexSize = 8;
SpineVirtualMesh.vertexSize_TwoColor = 12;
